import { booleanAttribute, Component, HostBinding, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'glxy-button-loading-indicator',
  templateUrl: './button-loading-indicator.component.html',
  styleUrls: ['./button-loading-indicator.component.scss'],
  imports: [MatProgressSpinnerModule],
})
export class ButtonLoadingIndicatorComponent {
  @HostBinding('class') class = 'glxy-button-loading-indicator';

  // isLoading cannot yet be an input signal, because libs/reports/dynamic/src/lib/services/report-loader.service.ts sets it directly.
  // The report-loader service should be refactored to properly support reactive behaviour.
  @HostBinding('class.is-loading')
  @Input({ transform: booleanAttribute })
  isLoading = false;
}
